import { render, staticRenderFns } from "./CurriculumWriteMainHeader.vue?vue&type=template&id=f1357df6&scoped=true&"
import script from "./CurriculumWriteMainHeader.vue?vue&type=script&lang=ts&"
export * from "./CurriculumWriteMainHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumWriteMainHeader.vue?vue&type=style&index=0&id=f1357df6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1357df6",
  null
  
)

export default component.exports